import React, { useState, useEffect} from "react";
import CountUp from 'react-countup';
import { Container, Row, Col } from "react-bootstrap";
import axios from 'axios';

export default function CountUpper(props) {
    const [clinics, setClinics] = useState(3);
    const [dentists, setDentists] = useState(4);
    const [bookings, setBookings] = useState(5);

    useEffect(() => {
        axios.post("https://uae-dentist-backend.herokuapp.com/fetch-numbers")
        .then((res) => {
            const data = res.data;
            console.log(data)
            setClinics(data.clinicCount);
            setDentists(data.dentistCount);
            setBookings(data.bookingCount);
        })
            // eslint-disable-next-line
    }, []);

      return (
        <div>
        <Container fluid="lg">
            <Row className="text-center h1 my-4" xs={1} md={1} lg={3} >
            <Col className='my-1' xs={12} md={12} lg={4}>
                <CountUp
                    start={0}
                    end={clinics}
                    duration={7}
                    separator=" "
                    decimals={0}
                    prefix=" "
                    suffix=" Clinics"
                />
            </Col>
            <Col className='my-1' xs={12} md={12} lg={4}>
            <CountUp
                start={0}
                end={dentists}
                duration={7}
                separator=" "
                decimals={0}
                prefix=""
                suffix=" Dentists"
            />
            </Col>

            <Col className='my-1' xs={12} md={12} lg={4}>
            <CountUp
                start={0}
                end={bookings}
                duration={7}
                separator=","
                decimals={0}
                prefix=""
                suffix=" Bookings "
            />
            </Col>
            </Row>
        </Container>
        </div>
      );

  }
  
